// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"153":"f0a16ddf","578":"f0a16ddf","730":"f0a16ddf","987":"f0a16ddf"}[chunkId] + ".chunk.css";
};